// Account data goes through the server routes in /api (C1 security fix).
// The app no longer holds a database key or talks to Supabase directly.
import { postApi } from './api';

// After the info form: create the row if the email is new (never overwrites, never sets premium).
export const saveUser = async (userData) => {
  try {
    await postApi('/api/profile', {
      action: 'create',
      email: userData.email,
      name: userData.name,
      phone: userData.phone,
      industry: userData.industry,
      profile_name: userData.profileName ?? undefined,
      responses: userData.responses,
    });
    return { success: true };
  } catch (error) {
    console.error('Error saving user:', error.message);
    return { success: false, error: error.message };
  }
};

// After the assessment: store profile, responses and industry.
export const updateUserProfile = async (email, name, profileName, responses, industry) => {
  try {
    await postApi('/api/profile', {
      action: 'update',
      email,
      name,
      profile_name: profileName,
      responses,
      industry,
    });
    return { success: true };
  } catch (error) {
    console.error('Error updating user profile:', error.message);
    return { success: false, error: error.message };
  }
};

export const checkUserPremium = async (email) => {
  try {
    const data = await postApi('/api/premium-status', { email });
    return { success: true, isPremium: data?.isPremium === true };
  } catch (error) {
    console.error('Error checking premium status:', error.message);
    return { success: false, isPremium: false };
  }
};

// Web/Android: confirm a Stripe Checkout Session on the server before unlocking premium.
export const verifyCheckout = async (sessionId) => {
  try {
    const data = await postApi('/api/verify-checkout', { session_id: sessionId });
    return { success: data?.isPremium === true, email: data?.email || null };
  } catch (error) {
    console.error('Error verifying checkout:', error.message);
    return { success: false, error: error.message };
  }
};

// iOS: RevenueCat purchase is confirmed by the server before the email is marked premium.
export const syncIOSEntitlement = async (appUserId, email) => {
  try {
    const data = await postApi('/api/ios-entitlement', { app_user_id: appUserId, email: email || undefined });
    return { success: true, isPremium: data?.isPremium === true };
  } catch (error) {
    console.error('Error syncing iOS entitlement:', error.message);
    return { success: false, isPremium: false };
  }
};

// Account deletion (Apple 5.1.1(v) / Google Play).
export const deleteUserAccount = async (email) => {
  try {
    await postApi('/api/delete-account', { email });
    return { success: true };
  } catch (error) {
    console.error('Error deleting user account:', error.message);
    return { success: false, error: error.message };
  }
};
